import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["tab"]
  static classes = ["active"]

  declare readonly tabTargets: HTMLElement[]
  declare readonly activeClass: string

  select(event: Event) {
    event.preventDefault()
    const clicked = event.currentTarget as HTMLElement
    const targetFrameId = clicked.dataset.frame
    const src = clicked.dataset.src
    if (!targetFrameId) return

    this.tabTargets.forEach((tab) => {
      const frameId = tab.dataset.frame
      if (!frameId) return
      const frame = document.getElementById(frameId)
      const isActive = tab === clicked
      tab.classList.toggle(this.activeClass, isActive)
      if (frame) frame.classList.toggle("hidden", !isActive)
    })

    const frame = document.getElementById(targetFrameId)
    if (frame && src && !frame.getAttribute("src")) {
      frame.setAttribute("src", src)
    }
  }
}
